// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { InputField } from "./InputField";
import PrimaryButton from "./PrimaryButton";

interface ChangeEmailModalProps {
  showNext?: () => void;
}

const ChangeEmailModal: React.FC<ChangeEmailModalProps> = ({showNext}) => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-tight mt-1 mb-4">We’ve sent you a code to your <br />current email. Please confirm.</p>
      <InputField label="Code from email" className="mb-3" />
      <div className="flex items-center mb-6 gap-1">
        <p className="text-[#9392A2] text-sm font-medium tracking-tight">Didn’t get a code? Resend in</p>
        <p className="text-[#8C84FF] text-sm font-medium tracking-tight">0:34</p>
      </div>
      <PrimaryButton onClick={() => showNext && showNext()} label="Proceed" className="py-2 w-full rounded-3xl" />
    </>
  );
};

export default ChangeEmailModal;